import { useMemo } from 'react';
import { useCharacterLimit } from "./use-character-limit";
export var useVisibleCategories = function useVisibleCategories(categories) {
  var _useCharacterLimit = useCharacterLimit(),
    currentLimit = _useCharacterLimit.currentLimit;
  var visibleCategories = useMemo(function () {
    var totalChars = 0;
    return categories.filter(function (category) {
      var newTotal = totalChars + category.name.length;
      if (newTotal <= currentLimit) {
        totalChars = newTotal;
        return true;
      }
      return false;
    });
  }, [categories, currentLimit]);
  var totalCategories = categories.length;
  var totalCharacters = visibleCategories.reduce(function (acc, category) {
    return acc + category.name.length;
  }, 0);
  var isExceedingLimit = totalCharacters > currentLimit;
  var isExceedingLimitCategories = visibleCategories.length < totalCategories;
  return {
    visibleCategories: visibleCategories,
    totalCategories: totalCategories,
    totalCharacters: totalCharacters,
    isExceedingLimit: isExceedingLimit,
    isExceedingLimitCategories: isExceedingLimitCategories
  };
};